import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-fela'
import { withRouter } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Message from 'views/components/presentationals/Message'
import Button from 'views/components/presentationals/atoms/Button'

class MessageHeader extends PureComponent {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }),
    styles: PropTypes.object.isRequired,
  }

  render() {
    const { profile, history, styles } = this.props

    if (profile.accountStatus === 'pending' && profile.accountValidationRequested) {
      return (
        <Message>
          <FormattedMessage id="components.smart.messageHeader.title.userStatusPending" />
        </Message>
      )
    }

    if (profile.accountStatus === 'pending' && !profile.accountValidationRequested) {
      return (
        <Message>
          <Grid>
            <Row center="xs" between="md" middle="md" className={styles.left}>
              <Col xs={12} md={8}>
                <FormattedMessage id="components.smart.messageHeader.title.userStatusPendingFirstTime" />
              </Col>
              <Col xs={12} md={4} className={styles.right}>
                <Button brand="quaternary" reversed={true} size="xs" onClick={() => history.push('/vouchers')}>
                  <FormattedMessage id="components.smart.messageHeader.button.addMyDocuments" />
                </Button>
              </Col>
            </Row>
          </Grid>
        </Message>
      )
    }

    if (profile.accountStatus === 'rejected') {
      return (
        <Message>
          <Row center="xs" between="xs" middle="md">
            <Col xs={12} md={8} className={styles.left}>
              <FormattedMessage id="components.smart.messageHeader.title.userStatusRejected" />{' '}
            </Col>
            <Col xs={12} md={4} className={styles.right}>
              <Button brand="tertiary" size="md" onClick={() => history.push('/vouchers')}>
                <FormattedMessage id="components.smart.messageHeader.button.checkMyDocuments" />
              </Button>
            </Col>
          </Row>
        </Message>
      )
    }

    return null
  }
}

const rules = {
  right: () => ({
    textAlign: 'right',
  }),
  left: () => ({
    textAlign: 'left',
  }),
}

export default connect(rules)(withRouter(MessageHeader))
